import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { allParcours, Parcours } from "../../modules/academy/parcours";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

export default function AcademyParcours() {
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Parcours</h1>
        <p className="text-sm text-slate-700 dark:text-slate-300">
          Les parcours te guident pas à pas à travers les thèmes clés de MixMind. Choisis un parcours adapté à ton âge et à ton objectif.
        </p>
        <div className="rounded-2xl border shadow-sm p-3 bg-white dark:bg-slate-900 dark:border-slate-700">
          <p className="text-xs text-slate-500 dark:text-slate-400">Filtres (placeholder)</p>
          <div className="flex gap-3 text-xs text-slate-500 dark:text-slate-400">
            <span>Age: tous</span>
            <span>Role: tous</span>
            <span>Niveau: tous</span>
          </div>
          {/* TODO MixMind: brancher les filtres (age/role/niveau). */}
        </div>
      </header>

      <div className="grid gap-4 md:grid-cols-2">
        {allParcours.length === 0 && (
          <div className="rounded-2xl border shadow-sm p-4 bg-white dark:bg-slate-900 dark:border-slate-700 text-sm text-slate-700 dark:text-slate-300">
            Aucun parcours disponible pour l’instant.
          </div>
        )}
        {allParcours.map((p: Parcours) => (
          <div
            key={p.id}
            className="rounded-2xl border shadow-sm p-4 bg-white dark:bg-slate-900 dark:border-slate-700 space-y-2"
          >
            <h2 className="text-lg font-semibold">{p.title}</h2>
            <p className="text-sm text-slate-700 dark:text-slate-300">{p.description}</p>
            <div className="flex gap-3 text-xs text-slate-500 dark:text-slate-400 flex-wrap">
              <span>Audience : {p.audience}</span>
              <span>Niveau : {p.level}</span>
              <span>Durée : {p.duration} min</span>
              <span>Étapes : {p.steps.length}</span>
            </div>
            <Link to={`/parcours/${p.id}`} className="text-sm text-indigo-600 hover:text-indigo-700 dark:text-indigo-300 dark:hover:text-indigo-200 underline-offset-2 hover:underline">
              Voir le parcours
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
